// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11327":"69f53981","35490":"69f53981","75168":"69f53981","97057":"4ef0bf47"}[chunkId] + ".chunk.css";
};